export default __webpack_public_path__ + "img/cvkLhiKX.23aca0a6.svg";